module.exports = {
    i18n: {
        defaultLocale: 'da',
        locales: ['da'],
    },
};
